/**
 * Renders dismissible alerts from the hidden template in the app layout.
 */
export function flashMessage(level, message) {
    const templateElement = document.getElementById('application_alert-template');
    const container = document.getElementById('application_alert');

    if (!templateElement || !container) {
        return;
    }

    container.insertAdjacentHTML('beforeend', templateElement.innerHTML);

    const alert = container.querySelector('.alert:last-child');

    if (!alert) {
        return;
    }

    alert.classList.add(`alert-${level}`);

    const content = alert.querySelector('[data-content]');

    if (content) {
        content.innerHTML = message;
    }
}

/**
 * Appends a floating alert straight to the body, for pages without the
 * layout alert template in scope.
 */
export function appendFixedAlert(level, message) {
    const alert = document.createElement('div');

    alert.className = `alert alert-${level} alert-dismissible alert-fixed`;
    alert.setAttribute('role', 'alert');
    alert.innerHTML = '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>'
        + `<strong>${message}</strong>`;

    document.body.appendChild(alert);
}
